/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";

import { WorkflowService } from "../../services/workflow.service";

import { Workflow } from "../../models/workflow";

@Component({
    templateUrl: './workflows.component.html'
})
export class WorkflowsComponent implements OnInit {

    workflows: WorkflowUI[] = [];
    
    constructor(
       private route: ActivatedRoute,
       private router: Router,
       private workflowService: WorkflowService
    ) { }

    ngOnInit() {
        this.loadWorkflows();
    }

    addWorkflow(): void {
        this.router.navigateByUrl(`/workflow/editor`);
    }

    editWorkflow(id: number): void {
        console.log("Edit workflow: " + id);
        this.router.navigateByUrl(`/workflow/editor/${id}`);
    }

    isEmptySelection(): boolean {
        return this.workflows.filter(workflow => workflow.selected).length == 0;
    }
        
    isAllSelected(): boolean {
        return this.workflows.every(workflow => workflow.selected);
    }
        
    selectAll(event: any): void {
        this.workflows.forEach(workflow => workflow.selected = event.target.checked);
    }

    onAddGroups(): void {
        
    }

    onRemoveGroup(): void {
    
    }

    onManageGroups(): void {

    }

    loadWorkflows(): void {
        const workflowList: WorkflowUI[] = [];

        this.workflowService.getAllWorkflows().then(
            response => {
                for (const workflow of response) {
                    const workflowUI = new WorkflowUI();
                    workflowUI.workflow = workflow;
                    workflowList.push(workflowUI);
                }

                this.workflows = workflowList;
            },
            error => {
                console.error('WorkflowsComponent: ', error);
            }
        );
    }
}

class WorkflowUI {
    selected = false;
    workflow: Workflow;
}
